export var FavoriteReferenceType;
(function (FavoriteReferenceType) {
    FavoriteReferenceType[FavoriteReferenceType["Folder"] = 0] = "Folder";
    FavoriteReferenceType[FavoriteReferenceType["Action"] = 1] = "Action";
    FavoriteReferenceType[FavoriteReferenceType["DataSource"] = 2] = "DataSource";
    FavoriteReferenceType[FavoriteReferenceType["Step"] = 3] = "Step";
    FavoriteReferenceType[FavoriteReferenceType["RuleStep"] = 4] = "RuleStep";
    FavoriteReferenceType[FavoriteReferenceType["FormControl"] = 5] = "FormControl";
    FavoriteReferenceType[FavoriteReferenceType["PageControl"] = 6] = "PageControl";
    FavoriteReferenceType[FavoriteReferenceType["Entity"] = 7] = "Entity";
    FavoriteReferenceType[FavoriteReferenceType["Report"] = 8] = "Report";
    FavoriteReferenceType[FavoriteReferenceType["NewRegistrationTemplate"] = 9] = "NewRegistrationTemplate";
})(FavoriteReferenceType || (FavoriteReferenceType = {}));
;
